import React from 'react';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import muiTheme from '../../utils/muiTheme'

const style = {
  container: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex:5001
  },
  refresh: {
    display: 'inline-block',
    position: 'relative',
  },
};

const LoadIndicator = () => (
  <div className="load-indicator" style={style.container}>
    <MuiThemeProvider muiTheme={muiTheme}>
      <RefreshIndicator
        size={60}
        left={10}
        top={0}
        status="loading"
        style={style.refresh}
      />
    </MuiThemeProvider>
  </div>
);

export default LoadIndicator;



// WEBPACK FOOTER //
// ./src/core/components/LoadIndicator.js